import styled from '@emotion/styled';

const Container = styled.div`
  position: relative;
`;

export { Container };
